import { render, staticRenderFns } from "./ReviewPage.vue?vue&type=template&id=1946d7f4&scoped=true&lang=html"
import script from "./ReviewPage.vue?vue&type=script&lang=js"
export * from "./ReviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1946d7f4",
  null
  
)

export default component.exports